<template>
  <nav id="navbarBlur" class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl" v-bind="$attrs"
    data-scroll="true" :class="isAbsolute ? 'mt-4' : 'mt-4'">
    <div class="px-4 py-1 container-fluid">
      <!-- Hamburger toggler: left side on mobile -->
      <a v-if="showHamburger" href="#" class="p-0 nav-link text-body d-flex align-items-center" @click.prevent="minNav">
        <div class="sidenav-toggler-inner">
          <i class="sidenav-toggler-line" :class="color ? 'bg-white' : ''"></i>
          <i class="sidenav-toggler-line" :class="color ? 'bg-white' : ''"></i>
          <i class="sidenav-toggler-line" :class="color ? 'bg-white' : ''"></i>
        </div>
      </a>
      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <!-- <material-input id="search" label="Search" :color="color ? 'light' : 'dark'"/> -->
        </div>
        <ul class="navbar-nav d-flex justify-content-end align-items-center">

          <push-prompt />
          <notification-bell :color="color" />

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle d-flex align-items-center py-0" href="#" role="button"
              data-bs-toggle="dropdown" aria-expanded="false" :class="color">
              <!-- <i class="material-icons" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">account_circle</i> -->
              <img class="avatar" :src="'data:image/png;base64,' + userImage" />
            </a>

            <ul class="dropdown-menu dropdown-menu-end">

              <!--Profile-->
              <li class="nav-item d-flex align-items-center">
                <router-link :to="{ name: 'User Profile' }"
                  class="px-0 nav-link font-weight-bold lh-1 d-flex align-items-center">
                  <i class="material-icons ms-2 spacer" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">
                    account_circle
                  </i>
                  {{this.$t('sidebar.userProfile')}}
                </router-link>
              </li>

              <hr class="m-0">

              <!--Dark mode-->
              <li class="nav-item d-flex align-items-center">
                <a href="#" role="switch" :aria-checked="isDarkMode"
                  class="px-0 nav-link font-weight-bold lh-1 d-flex align-items-center w-100"
                  @click.prevent="toggleDarkMode">
                  <i class="material-icons ms-2 spacer" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">
                    dark_mode
                  </i>
                  {{this.$t('sidebar.darkMode')}}
                  <span class="form-check form-switch mb-0 ps-0" :class="isRTL ? 'me-auto ms-2' : 'ms-auto me-2'">
                    <input class="form-check-input mt-0 ms-0 dark-mode-switch" type="checkbox" tabindex="-1"
                      :checked="isDarkMode" />
                  </span>
                </a>
              </li>

              <hr class="m-0">

              <!--User Manual-->
              <li class="nav-item d-flex align-items-center">
                <router-link :to="{ name: 'User Manual' }"
                  class="px-0 nav-link font-weight-bold lh-1 d-flex align-items-center">
                  <i class="material-icons ms-2 spacer" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">
                    menu_book
                  </i>
                  {{this.$t('sidebar.userManual')}}
                </router-link>
              </li>

              <hr class="m-0">

              <!--Logout-->
              <li class="nav-item d-flex align-items-center">
                <router-link :to="{ name: 'Login' }" class="px-0 nav-link font-weight-bold lh-1 d-flex align-items-center"
                  @click="logout">
                  <i class="material-icons ms-2 spacer" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'">
                    logout
                  </i>
                  {{this.$t('sidebar.logOut')}}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
</nav>
</template>
<script>
// import MaterialInput from "@/components/MaterialInput.vue";
import { mapMutations, mapState } from "vuex";
import { EventBus } from '../../components/event-bus.js';
import api from "../../services/api"
import authService from '../../services/authService';
import { clearSession } from '../../services/tokenService';
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { defaultUserImage } from '../../components/Image Bytes/imagebytes'
import { activateDarkMode, deactivateDarkMode } from "@/assets/js/dark-mode";
import NotificationBell from './NotificationBell.vue'
import PushPrompt from './PushPrompt.vue'

export default {
  name: "Navbar",
  components: {
    // MaterialInput,
    NotificationBell,
    PushPrompt,
  },
  props: {
    minNav: {
      type: Function,
      default: () => { },
    },
    color: {
      type: String,
      default: "text-body",
    },
  },
  data() {
    return {
      showMenu: false,
      userImage: '',
      isMobile: window.innerWidth <= 1200,
    };
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute", "isDarkMode"]),
    currentRouteName() {
      return this.$route.name;
    },
    showHamburger() {
      return this.isMobile;
    },
  },
  created() {
    this.minNav;
    this.setUserImage();
    EventBus.$on('user-image-updated', this.onUserImageUpdated);
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    EventBus.$off('user-image-updated', this.onUserImageUpdated);
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),

    handleResize() {
      this.isMobile = window.innerWidth <= 1200;
    },

    onUserImageUpdated(newImage) {
      this.userImage = newImage;
      sessionStorage.setItem('userImage', newImage);
    },

    setUserImage() {
      const token = Cookies.get('accessToken');
      if (!token) {
        this.userImage = defaultUserImage;
        return;
      }
      const decodedToken = jwtDecode(Cookies.get('accessToken'));
      let userImage = sessionStorage.getItem('userImage');
      if (userImage !== null && userImage !== '') {
        this.userImage = userImage;
      }
      else {
        this.userImage = defaultUserImage;
        let userUrl = `/User/${decodedToken.UserIdentifier}`;
        api.get(userUrl)
          .then(response => {
            if (response.data.userImageThumbnailBytes !== null && response.data.userImageThumbnailBytes !== '') {
              this.userImage = response.data.userImageThumbnailBytes;
              sessionStorage.setItem('userImage', this.userImage);
            }
          })
          .catch(error => {
            console.error('API request error:', error); // eslint-disable-line no-console
          });
      }
    },

    toggleSidebar() {
      this.navbarMinimize();
    },

    toggleDarkMode() {
      const isDarkMode = !this.$store.state.isDarkMode;
      this.$store.state.isDarkMode = isDarkMode;
      localStorage.setItem('darkMode', String(isDarkMode));
      if (isDarkMode) {
        activateDarkMode();
      } else {
        deactivateDarkMode();
      }
    },

    logout() {
      authService.logout();
      // Clears the access token + legacy cookie and asks the server to drop the HttpOnly refresh cookie.
      clearSession();
      this.$router.push('/login');
    },
  },
};
</script>
<style scoped>
  .dropdown-toggle::after {
    display: none !important;  /* Hide Bootstrap's default arrow/box */
  }

  .spacer {
    margin-left: 4px;
  }

  /* The whole row handles the click; the switch only shows the state */
  .dark-mode-switch {
    pointer-events: none;
  }
</style>
